// src/app/hooks.ts
// Typed Redux hooks and useAuth convenience hook.
import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux'
import type { RootState, AppDispatch } from './store'

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

/** Convenience hook — returns the entire auth slice state. */
export function useAuth() {
  return useAppSelector((state) => state.auth)
}
